import { CreateElement, VNode, VueConstructor } from "vue";
import Vue from "vue";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import MessageItem from "./MessageItem";

const context = require.context("./", false, /[a-zA-Z]*\.vue/);

export function getMessageView(message: Message): VueConstructor<Vue> {
  if (Number(message.senderId) > 0) {
    return MessageItem;
  }
  if (message.details) {
    const type = message.details.type;
    const key = context
      .keys()
      .find(k => k.match(new RegExp(`SystemMessage${type.substr(0, 1).toUpperCase()}${type.substr(1)}.vue$`)));
    if (key) return context(key).default;
  }
  return Vue.extend({
    functional: true,
    render: (h: CreateElement): VNode => h(),
  });
}
